import { createReportDetailsTab } from './createReportDetailsTab'

export default createReportDetailsTab({ displayName: 'ReportDeliveriesTab' })
